import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const vocabularyGroupsManifest: FeatureManifest = {
  id: 'english-knowledge-vocabulary-groups',
  path: 'english-knowledge/vocabulary-groups/catalogs/*',
  navPath: '/english-knowledge/vocabulary-groups/catalogs',
  label: 'Danh mục',
  description: 'Sắp xếp từ vựng thành các bộ học tập',
  navigationGroup: { id: 'vocabulary-groups', label: 'Nhóm từ vựng' },
  load: () => import('./entry'),
}
